export const createProjectForm = {
    id: null,
    name: "",
    description: "",
    modules: ["module_globus"],
    map_files: [],
    users: [],
    is_archive: false,
    is_owner: true
};